<footer
  class="flex w-full align-items-center gap-2 p-2 text-white text-sm lg:max-width-lg footer"
>
  2023 - Portal de serviços da Companhia Catarinense de Águas e Saneamento
</footer>
